import check from '@/public/images/check.svg';
import doc from '@/public/images/doc.svg';
import download from '@/public/images/download.svg';
import ghost from '@/public/images/ghost.svg';
import help from '@/public/images/help.svg';
import laptop from '@/public/images/laptop.svg';
import light from '@/public/images/light-dark.svg';
import responsive from '@/public/images/responsive.svg';
import settings from '@/public/images/settings.svg';
import update from '@/public/images/update.svg';
import users from '@/public/images/users-profiles.svg';
import wand from '@/public/images/wand.svg';

import { IAdvInfo } from '../interfaces/advantageInterface';

export const advInfoShort: IAdvInfo[] = [
    {
        advName: 'Ghost 5.0+',
        advDescr: `Compatible with Ghost 5.0+, our theme uses the latest web standards.`,
        advLogo: ghost,
        advAlt: 'Ghost',
    },
    {
        advName: 'Responsive Design',
        advDescr:
            'Deliver seamless display and functionality across all devices with responsive design.',
        advLogo: responsive,
        advAlt: 'Responsive Design',
    },
    {
        advName: 'expert team',
        advDescr:
            'Crafted by experts, our themes combine innovation and skill for top-tier performance.',
        advLogo: users,
        advAlt: 'Experts',
    },
    {
        advName: 'Dedicated Support',
        advDescr:
            'Receive responsive, professional support whenever you need assistance.',
        advLogo: help,
        advAlt: 'Support',
    },
];

export const advInfoFull: IAdvInfo[] = [
    {
        advName: 'Easy to Deploy',
        advDescr:
            'Deploy your Ghost theme effortlessly with a fast, guided setup that ensures minimal downtime.',
        advLogo: download,
        advAlt: 'Easy to Deploy',
    },
    {
        advName: 'Custom Settings',
        advDescr:
            'Customize layouts, fonts, and more easily using a powerful settings panel tailored to your brand.',
        advLogo: settings,
        advAlt: 'Settings',
    },
    {
        advName: 'Great Performance',
        advDescr: `Experience fast, smooth website performance with themes optimized for quick load times.`,
        advLogo: light,
        advAlt: 'Performance',
    },
    {
        advName: 'Developer Friendly',
        advDescr:
            'Benefit from clean, well-structured code for easy customization and seamless integration.',
        advLogo: laptop,
        advAlt: 'Developer Friendly',
    },
    {
        advName: 'Multi-purpose Design',
        advDescr:
            'Adapt our versatile themes effortlessly to suit any content type or industry.',
        advLogo: wand,
        advAlt: 'Multi-purpose Design',
    },
    {
        advName: 'Flexible Buying Options',
        advDescr:
            'Choose flexible purchase options — from individual themes to full access bundles.',
        advLogo: check,
        advAlt: 'Flexible Buying Options',
    },
    {
        advName: 'Regular Updates',
        advDescr:
            'Receive regular updates that add new features while maintaining security and Ghost compatibility.',
        advLogo: update,
        advAlt: 'Regular Updates',
    },
    {
        advName: 'Well Documented',
        advDescr:
            'Access comprehensive documentation covering initial setup to advanced customization.',
        advLogo: doc,
        advAlt: 'Documentation',
    },
];
